import { ROUTES } from "../../../constants/routes";

export const func_forget_password = {
    sendMail: (email, mutate_forgotten_password) => {
        return mutate_forgotten_password(email);
    },
    goBack: (navigate, email) => {
        navigate(ROUTES.login, {
            state: {
                email,
            },
        });
    },
};
